<template>
  <div id="productModal">
    <!-- Modal content -->
    <div class="product-modal-content" style="padding:20px;padding-bottom:50px;">
      <span class="close">&times;</span>
      <span class="loader" v-if="showLoader"></span>
      <div v-if="switchForm" class="login-content">
        <div>
          <h4 style="text-align:center;padding:20px;">Iniciar sesión</h4>
        </div>
        <div class="">
          <div class="container">
            <div class="form-group">
              <input 
                type="text" 
                name="email" 
                placeholder="Correo"
                v-model="email">
            </div>
            <div class="form-group">
              <input
                type="password" 
                name="password" 
                placeholder="contraseña"
                v-model="password">
            </div>
          </div>
          <div class="container">
            <button
            class="l-s-btn"
            @click.prevent="login">Iniciar sesión</button>
            <p class="error">{{ getErrors.message }}</p>
          </div>
          <div class="container" style="text-align:center;padding:10px;">
            <p>¿No tienes una cuenta? <a class="signup-link-btn" @click.prevent="switchForm=false">Regístrate</a></p>
          </div>
        </div>
      </div>
      <div v-else class="signup-content">
        <div>
          <h4 style="text-align:center;padding:20px;">Crear cuenta</h4>
        </div>
        <div class="container">
          <div class="form-group">
            <input
            type="text" 
            name="name" 
            v-model="user.name"
            placeholder="Nombre y apellido"
            >
            <p v-if="formErrors.name" class="form-error"><i class="fas fa-exclamation-circle"></i> {{ formErrorsMessage.name }}</p>
          </div>
          <div class="form-group">
            <input 
            type="text" 
            name="email"
            v-model="user.email" 
            placeholder="Correo (usuario)"
            >
            <p v-if="formErrors.email" class="form-error"><i class="fas fa-exclamation-circle"></i> {{ formErrorsMessage.email }}</p>
          </div>
          <div class="form-group">
            <input  
            type="password" 
            name="password" 
            v-model="user.password"
            placeholder="Contraseña"
            >
            <p>Usa 8 o más catacteres mezclando letras mayusculas, minusculas y números.</p>
            <p v-if="formErrors.password" class="form-error"><i class="fas fa-exclamation-circle"></i> {{ formErrorsMessage.password }}</p>
          </div>
          <div class="form-group">
            <input 
            type="password" 
            name="confirmpassword"
            v-model="user.confirmPassword"
            placeholder="Confirmar contraseña"
            >
            <p v-if="formErrors.confirmPassword" class="form-error"><i class="fas fa-exclamation-circle"></i> {{ formErrorsMessage.confirmPassword }}</p>
          </div>
          <div class="form-group">
            <input 
            type="text" 
            name="email" 
            v-model="user.company"
            placeholder="Empresa"
            >
            <p v-if="formErrors.company" class="form-error"><i class="fas fa-exclamation-circle"></i> {{ formErrorsMessage.company }}</p>    
          </div>
          <div class="form-group">
            <select v-model="user.type" style="width:100%;padding:8px;">
              <option disabled value="">Tipo de usuario</option>
              <option>Productor</option>
              <option>Técnico</option>
              <option>Subdistribuidor</option>
            </select>
          </div>
        </div>
        <div class="container">
          <button
            class="l-s-btn"
            @click.prevent="signup">Crear cuenta</button>

        </div>
        <div class="container" style="text-align:center;padding:10px;">
          <p>¿Tienes una cuenta? <a class="login-link-btn" @click.prevent="switchForm=true">Inicia sesión</a></p>

        </div>
      </div>
      <div class="container">
        <p style="text-align:center;color:#333;">{{signupSuccessfulMessage}}</p>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      email: '',
      password: '',
      switchForm: true,
      user: {
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        company: '',
        type: ''
      },
      formErrors: {
        name: false,
        email: false,
        password: false,
        confirmPassword: false,
        company: false,
        type: false
      },
      formErrorsMessage: {
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        company: '',
        type: ''
      },
      signupSuccessfulMessage: '',
      showLoader: false
    }
  },
  computed: {
    getErrors () {
      return this.$store.getters.loginError
    }
  },
  methods: {
    login () {
      const formData = {
        email: this.email,
        password: this.password
      }
      this.$store.dispatch('login', { email: formData.email, password: formData.password })
      this.showLoginModal = false
    },
    signup () {
      var vm = this

      const formData = {
        name: this.user.name,
        email: this.user.email,
        password: this.user.password,
        company: this.user.company,
        type: this.user.type
      }

      if (this.user.name === '') {
        this.formErrors.name = true
        this.formErrorsMessage.name = 'Ingresa un usuario'
      } else if (this.user.name.length <= 3) {
        this.formErrors.name = true
        this.formErrorsMessage.name = 'Ingresa un nombre con minimo 3 caracteres'
      } else {
        this.formErrors.name = false
        this.formErrorsMessage.name = ''
      }

      if (this.user.email === '') {
        this.formErrors.email = true
        this.formErrorsMessage.email = 'Ingresa un email'
      } else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email)) {
        this.formErrors.email = true
        this.formErrorsMessage.email = 'Ingresa un email con formato correcto'
      } else {
        axios.get('/user/checkUserEmail?query=' + this.user.email)
          .then(res => {
            if (res.data.emailExists === true) {
              this.formErrors.email = true
              console.log('Email already exists!')
              this.formErrorsMessage.email = 'Ya existe un usuario con ese email, ingresa otro email'
            } else {
              this.formErrors.email = false
              this.formErrorsMessage.email = ''
            }
          })
          .catch(err => console.log(err))
      }

      if (this.user.password === '') {
        this.formErrors.password = true
        this.formErrorsMessage.password = 'Ingresa una contraseña'
      } else if (this.user.password.length < 8) {
        this.formErrors.password = true
        this.formErrorsMessage.password = 'Ingresa más de 8 caracteres'
      } else if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/.test(this.user.password)) {
        this.formErrors.password = true
        this.formErrorsMessage.password = 'Mezcla letras mayusculas, minusculas y números'
      } else {
        this.formErrors.password = false
        this.formErrorsMessage.password = ''
        if (this.user.confirmPassword === '') {
          this.formErrors.confirmPassword = true
          this.formErrorsMessage.confirmPassword = 'Confirma la contraseña'
        } else if (this.user.confirmPassword !== this.user.password) {
          this.formErrors.confirmPassword = true
          this.formErrorsMessage.confirmPassword = 'Las contraseñas no coninciden'
        } else {
          this.formErrors.confirmPassword = false
          this.formErrorsMessage.confirmPassword = ''
        }
      }

      if (this.user.company === '') {
        this.formErrors.company = true
        this.formErrorsMessage.company = 'Ingresa la empresa'
      } else if (this.user.company.length <= 3) {
        this.formErrors.company = true
        this.formErrorsMessage.company = 'Ingresa un nombre de la empresa con minimo 3 caracteres'
      } else {
        this.formErrors.company = false
        this.formErrorsMessage.company = ''
      }

      let errors = Object.values(this.formErrors)
      let formValidError = errors.includes(true)

      if (!formValidError) {
        console.log(formData)

        // this.signupSuccessfulMessage = 'Su solicitud fue enviada con exito, pronto nos pondremos en contacto con usted'
     
        this.user.name = ''
        this.user.email = ''
        this.user.password = ''
        this.user.confirmPassword = ''
        this.user.company = ''
        this.user.type = ''
        
        axios.put('/user/signup', formData)
        .then(res => {
          vm.$store.dispatch('showMessage', { message: 'Usuario agregado con exito', status: true })

          this.signupSuccessfulMessage = 'Su solicitud de acceso fue enviada con exito, su solicitud estara en proceso de aprobación'

          setTimeout(() => {
            vm.$store.commit('hide')
            this.signupSuccessfulMessage = ''
          }, 7000)
          
        })
        .catch(err => console.log(err))
      }

    }
  }
};
</script>

<style scoped>
/* The Modal (background) */
#productModal {

  position: fixed; /* Stay in place */
  z-index: 9999 !important; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.5); /* Black w/ opacity */
  transition: opacity .3s ease;
}

/* Modal Content/Box */
.product-modal-content {
  background-color: #fefefe;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 5% auto;  
  /*margin-top: 15%;*/
  /*padding: 20px;*/
  /*border: 1px solid #888;*/
  width: 400px; /* Could be more or less, depending on screen size */
}

.modal-content-wrapper {
  padding: 30px;
}

.form-product-container {
  /*background-color: rgba(0,0,0,0.4);*/
  padding: 0 !important;
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  display: none;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.product-info {
  font-size: 20rem;
}

.document-link-container {
  padding: 20px 0;
}

.product-info-item {
  padding: 8px 0;
  font-size: 18px;
}

.product-info-item span{
  font-weight: bold;
}

.product-document {
  color: #43a553;
  cursor: pointer;
  text-decoration: underline;
}

input {
  padding:8px;
  width:100%;
}

.l-s-btn {
  width:100%;
  margin: 10px 0;
  padding: 8px 0;
  border-radius:4px;
  background-color: #43a553;
  color:#fff;
  font-size:16px;
  border: none;
  cursor:pointer;
  font-weight:500;
}

.form-group {
  margin-bottom: 14px;
}

.signup-link-btn, .login-link-btn {
  color:#43a553;
  font-weight:bold;
  cursor: pointer;
}

.form-error {
  color: red;
}

.loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 150px;
  height: 150px;
  margin: -75px 0 0 -75px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error {
  color:red;
}


</style>